import React from "react";
import AboutCompo from "../components/AboutCompo/AboutCompo";
import Hero from "../components/Hero/Hero";
import ServiceCompo from "../components/serviceCompo/serviceCompo";
import BookToday from "../components/BookToday/BookToday";
import Testimonials from "../components/Testimonials/Testimonials";
import Faq from "../components/Faq/Faq";

const Home = () => {
  return (
    <div>
      <Hero />
      <AboutCompo />
      <ServiceCompo />
      <div className="mb-12">
        <div className="text-center py-8 flex items-center justify-center">
          <h2 className="text-4xl font-bold text-yellow-500">
            Send Booking Details
          </h2>
        </div>
        <div className="flex flex-col lg:flex-row">
          {/* Left side for the image */}
          <div className="w-full lg:w-1/2 flex items-center justify-center relative mb-6 lg:mb-0">
            <img
              src="/assets/gallery/g7.jpeg"
              alt="Book Image"
              className="w-full h-full p-4 rounded-lg object-cover"
            />
          </div>
          {/* Right side for the Booktoday component */}
          <div className="w-full lg:w-1/2 flex items-center justify-center">
            <BookToday />
          </div>
        </div>
      </div>

      <div>
        <Testimonials />
      </div>
      <div>
        <Faq />
      </div>
    </div>
  );
};

export default Home;
